import React from 'react';
import './EmptyState.css';

export default function EmptyState({ icon, title, message, action }) {
  return (
    <div className="empty-state-modern">
      <div className="empty-state-icon">
        <span className="material-symbols-rounded">{icon}</span>
      </div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-message">{message}</p>
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
